import { createAction } from "@reduxjs/toolkit";
import _ from "lodash";
import { TCardioActivity, TClass } from "models/facility-options";

import { emailControl, emailDestination, memberStatus, trainingPartner } from "./data";
import {
  resetCardioActivitiesList,
  setFacilitySettings,
  setShowClassAddEditModal,
} from "./facilityOptionsSlice";

interface FacilityOptionsState {
  loading: boolean;
  settings: {
    OPTIONS: any;
    PAY_SCHEDULE: any[];
  } | null;
  cardioActivityList: TCardioActivity[];
  cardioActivityListPagination: any;
  selectedCardioActivityList: TCardioActivity[];
  showClassAddEditModal: boolean;
}

interface FacilitySettingsPayload {
  PAY_SCHEDULE: any[];
  OPTIONS: object;
}

interface CardioActivityListPayload {
  data: TCardioActivity[];
  pagination: any;
}

interface ClassListPayload {
  data: TClass[];
  pagination: any;
}

const getFacilitySettingsAction = createAction("facility-options/getSettings");
const saveFacilitySettingsAction = createAction<object>("facility-options/saveSettings");

const getSelectedCardioActivitiesAction = createAction(
  "facility-options/getSelectedCardioActivities"
);
const getCardioActivitiesAction = createAction<object>("facility-options/getCardioActivities");
const saveCardioActivitiesAction = createAction<object>("facility-options/saveCardioActivities");

const formattedSettingsData = (settings) => {
  return {
    emailControl: _.cloneDeep(emailControl).map((o) => {
      if (settings?.OPTIONS && o.key in settings?.OPTIONS)
        o.value = settings?.OPTIONS[o.key]?.value || o.value;
      return o;
    }),
    emailDestination: _.cloneDeep(emailDestination).map((o) => {
      if (settings?.OPTIONS && o.key in settings?.OPTIONS)
        o.value = settings?.OPTIONS[o.key]?.value || o.value;
      return o;
    }),
    memberStatus: _.cloneDeep(memberStatus).map((o) => {
      if (settings?.OPTIONS && o.key in settings?.OPTIONS)
        o.value = settings?.OPTIONS[o.key]?.value || o.value;
      if (o.daysInput) {
        o.checkboxValue = !!o.value;
      }
      return o;
    }),
    trainingPartner: _.cloneDeep(trainingPartner).map((o) => {
      if (settings?.OPTIONS && o.key in settings?.OPTIONS)
        o.value = settings?.OPTIONS[o.key]?.value || o.value;
      return o;
    }),
  };
};

export {
  CardioActivityListPayload,
  ClassListPayload,
  FacilityOptionsState,
  FacilitySettingsPayload,
  formattedSettingsData,
  getCardioActivitiesAction,
  getFacilitySettingsAction,
  getSelectedCardioActivitiesAction,
  resetCardioActivitiesList,
  saveCardioActivitiesAction,
  saveFacilitySettingsAction,
  setFacilitySettings,
  setShowClassAddEditModal,
};
